import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { ServicoService } from '../../status/servico/servico-service/ServicoService';
import { TranslateModule } from '@ngx-translate/core';
import { PaginatorModule } from 'primeng/paginator';
import { ChartsModule } from 'ng2-charts';
import { CheckboxModule } from 'primeng/checkbox';
import { ComumModule } from '../../../shared/comum.module';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AtualizarClienteComponent } from './atualizar-cliente.component';

@NgModule({
  imports: [
    HttpClientModule,
    BrowserAnimationsModule,
    TableModule,
    ButtonModule,
    DropdownModule,
    InputTextModule,
    FormsModule,
    CommonModule,
    ComumModule,
    ChartsModule,
    CheckboxModule,
    DropdownModule,
    PaginatorModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    AtualizarClienteComponent,
  ],
  declarations: [
    AtualizarClienteComponent
  ],
  providers: [
    ServicoService
  ]

})
export class AtualizarClienteModule { }
